import { render, staticRenderFns } from "./addPro.vue?vue&type=template&id=06d3f254&scoped=true"
import script from "./addPro.vue?vue&type=script&lang=js"
export * from "./addPro.vue?vue&type=script&lang=js"
import style0 from "./addPro.vue?vue&type=style&index=0&id=06d3f254&prod&lang=stylus&scoped=true"
import style1 from "./addPro.vue?vue&type=style&index=1&id=06d3f254&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d3f254",
  null
  
)

export default component.exports